import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"
import menuMessages from "../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Sala de Juntas',
            tblTitle: 'Lista de Salas',
            tblbutton: 'Nueva Sala',
            mdlSave: 'Guardar',
            mdlCancel: 'Cancelar',
            mdltext1: 'Nombre',
            mdltext2: 'Localidad',
            mdltext3: 'Descripción',
            mdltext4: 'Atributos',
            mdltext5: 'Capacidad',
            mdltext6: 'Habilitada',
        },
        en: {
            moduleTitle: 'Meeting Rooms',
            tblTitle: 'Meeting List',
            tblbutton: 'New Meeting',
            mdlSave: 'Save',
            mdlCancel: 'Cancel',
            mdltext1: 'Name',
            mdltext2: 'Location',
            mdltext3: 'Description',
            mdltext4: 'Attribute',
            mdltext5: 'Capacity',
            mdltext6: 'Enabled',
        }
    }
}

export default _.merge(messages, defaultMessages, menuMessages)